import { render } from "./reloadModal.vue?vue&type=template&id=c4dae10c"
import script from "./reloadModal.vue?vue&type=script&lang=js"
export * from "./reloadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__